import { render, staticRenderFns } from "./MinorWaitingTutorConfirm.vue?vue&type=template&id=97b7c3f4&scoped=true&"
import script from "./MinorWaitingTutorConfirm.vue?vue&type=script&lang=js&"
export * from "./MinorWaitingTutorConfirm.vue?vue&type=script&lang=js&"
import style0 from "./MinorWaitingTutorConfirm.vue?vue&type=style&index=0&id=97b7c3f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b7c3f4",
  null
  
)

export default component.exports